
import { CONSTANTS } from "../../constants";

export default {
  data() {
    return {
      subscriberEmail: "",
    };
  },
  methods: {
    async addToSubscriber() {
      const validateEmail = (email) => {
        return email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      };
      if (validateEmail(this.subscriberEmail)) {
        const options = {
          method: "POST",
          headers: {
            Authorization: `Bearer ${CONSTANTS.SUBSCRIBE_API_KEY}`,
            "Content-Type": "application/json",
          },
          mode: "cors",
          body: JSON.stringify({
            data: { email: this.subscriberEmail.toLowerCase() },
          }),
        };
        const resp = await fetch(
          `${CONSTANTS.BLOG_API_ENDPOINT}/api/subscribers`,
          options
        ).then((res) => res.json());
        if (resp.data) {
          this.$toast.success("Successfully subscribed").goAway(2000);
          this.subscriberEmail = "";
        } else {
          this.$toast
            .error("Email already exists, use a new one.")
            .goAway(2000);
        }
      } else {
        this.$toast.info("Should be a valid email address").goAway(2000);
      }
    },
  },
};
